import { render, staticRenderFns } from "./SalidaCaja.vue?vue&type=template&id=2d030947"
import script from "./SalidaCaja.vue?vue&type=script&lang=js"
export * from "./SalidaCaja.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports